import type { CSSProperties } from "react";

/**
 * Returns node style without `width` / `height` so layout dimensions stay on
 * `RenderNodeBase.width` / `height` (or fit-content modes), not CSS overrides.
 */
export function nodeStyleWithoutDimensions(
  style: Record<string, unknown>,
): CSSProperties {
  const { width: _width, height: _height, ...rest } = style;
  return rest as CSSProperties;
}
